import { useEffect, useMemo, useState } from 'react'

/**
 * @param {{
 *  initialValue: boolean
 *  root?: IntersectionObserverInit['root'],
 *  rootMargin?: IntersectionObserverInit['rootMargin'],
 *  threshold?: IntersectionObserverInit['threshold'],
 * }} options
 */
function useIsInView(options) {
  const [ref, setRef] = useState(null)
  const [isInView, setIsInView] = useState(options.initialValue)
  const observer = useMemo(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]) {
          const entry = entries[0]
          setIsInView(entry.isIntersecting)
        }
      },
      {
        root: options.root,
        rootMargin: options.rootMargin,
        threshold: options.threshold,
      },
    )
    return observer
  }, [options.root, options.rootMargin, options.threshold])
  useEffect(() => {
    if (ref) {
      observer.observe(ref)
    }
    return () => {
      if (ref) {
        observer.unobserve(ref)
      }
    }
  }, [ref, observer])
  return [setRef, isInView]
}

export default useIsInView
